import { create } from 'zustand/react';
import { InvokeRpc } from '../../../util/hubs/types';
import { LobbyType } from '../../../features/workflow/types';

type AgentInboxRpcServer = {
  UpdatePriorityList: (subscription: LobbyType, idA: number, idB: number) => void;
  RemovePriority: (activityId: number) => void;
};

type InboxHubStore = {
  isConnected: boolean;
  isPriorityUpdating: boolean;
  isUpdating: boolean;
  /** When true, inbox hub updates for the Agent Inbox are ignored (per-user FE pause). */
  isEmailIntakePaused: boolean;
  setIsPriorityUpdating: (value: boolean) => void;
  setIsUpdating: (value: boolean) => void;
  setIsEmailIntakePaused: (value: boolean) => void;
  invoke: InvokeRpc<AgentInboxRpcServer> | null;
  setInvoke: (cb: InvokeRpc<AgentInboxRpcServer>) => void;
};

export const useInboxHubStore = create<InboxHubStore>((set) => ({
  isConnected: false,
  isPriorityUpdating: false,
  isUpdating: false,
  isEmailIntakePaused: false,
  invoke: null,
  setIsPriorityUpdating: (value: boolean) => set({ isPriorityUpdating: value }),
  setIsUpdating: (value: boolean) => set({ isUpdating: value }),
  setIsEmailIntakePaused: (value: boolean) => set({ isEmailIntakePaused: value }),
  setInvoke: (invoke) => set({ invoke, isConnected: true })
}));
